// extracted by mini-css-extract-plugin
export default {"items":"poster-editor-layout-item-spacing-panel-module__items--A8Tur"};